<div class="header">
  <button
    type="button"
    class="mobile-menu-toggle"
    aria-label="Abrir menu"
    (click)="sidebarState.toggle()"
  >
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
      <line x1="3" y1="6" x2="21" y2="6"></line>
      <line x1="3" y1="12" x2="21" y2="12"></line>
      <line x1="3" y1="18" x2="21" y2="18"></line>
    </svg>
  </button>

  <!-- Sininho: leva para a tela de Alertas. O número só aparece quando há
       alerta não lido - badge zerado vira ruído e some do radar. -->
  <button
    type="button"
    class="sino-button"
    [class.tem-alerta]="alertasNaoLidos() > 0"
    [attr.aria-label]="rotuloSino()"
    [title]="rotuloSino()"
    (click)="abrirAlertas()"
  >
    <svg width="20" height="20" viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true">
      <path d="M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160Zm320-300Zm0 420q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80ZM320-280h320v-280q0-66-47-113t-113-47q-66 0-113 47t-47 113v280Z"/>
    </svg>

    <span class="sino-badge" *ngIf="alertasNaoLidos() > 0">
      {{ alertasNaoLidos() > 99 ? '99+' : alertasNaoLidos() }}
    </span>
  </button>

  <div class="user-area" *ngIf="currentUser$ | async as user">
    <button class="avatar-button" type="button" (click)="toggleMenu($event)">
      {{ getInitials(user.nome) }}
    </button>

    <div class="user-menu" *ngIf="menuAberto" (click)="$event.stopPropagation()">
      <div class="user-info">
        <strong>{{ user.nome }}</strong>
        <span class="user-email">{{ user.email }}</span>
      </div>

      <button type="button" class="menu-item" (click)="gerenciarUsuarios()">
        Gerenciar usuários
      </button>

      <button type="button" class="menu-item danger" (click)="sair()">
        Sair
      </button>
    </div>
  </div>
</div>